import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
  configApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
} from '@backstage/core-compat-api';
import { rootRouteRef } from './routes';
import { parseableApiRef } from './api';
import { ParseableClient } from './api/ParseableClient';

// Migrate the page using PageBlueprint
const parseableDatasetsPage = PageBlueprint.make({
  params: {
    path: '/parseable-datasets',
    routeRef: convertLegacyRouteRef(rootRouteRef),
    loader: () =>
      import('./components/ParseableDatasetsPage').then(m =>
        compatWrapper(<m.ParseableDatasetsPage />),
      ),
  },
});

// Migrate the API using ApiBlueprint
const parseableApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: parseableApiRef,
      deps: {
        configApi: configApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ configApi, fetchApi, identityApi }) =>
        new ParseableClient({
          configApi,
          fetchApi,
          identityApi,
        }),
    }),
});

// Create the new frontend plugin
export default createFrontendPlugin({
  pluginId: 'parseable-datasets',
  extensions: [parseableDatasetsPage, parseableApi],
  routes: {
    root: convertLegacyRouteRef(rootRouteRef),
  },
});
